import store from '../../../../../store/redux/store';
import { FlowsQuestionAnswer } from '../../../../../types/FlowsTypes';

const getDuplicateQuestionsAnswers = (
  amountQuestionId: string,
  index?: number,
): FlowsQuestionAnswer[] => {
  const {
    answers,
    metaData: { duplicateQuestionMapping },
  } = store.getState().flows;

  const duplicateQuestionGroups = duplicateQuestionMapping?.[amountQuestionId];
  const duplicateQuestionAnswers = answers.filter(
    ({ id, groupId, index: answerIndex }) =>
      (duplicateQuestionGroups?.includes(groupId) &&
        (index == null || index === answerIndex)) ||
      amountQuestionId === id,
  );

  return duplicateQuestionAnswers || [];
};

export default getDuplicateQuestionsAnswers;
